import { FC, useState, useEffect } from 'react';
import './style.scss';
import { UploadFile } from 'antd';

const ImgPreview: FC<{ uploadResult: UploadFile[] }> = ({ uploadResult }) => {
    const [data, setData] = useState<string[]>([]);
    useEffect(() => {
        const newData: string[] = [];
        uploadResult.forEach((file) => {
            let reader = new FileReader();
            reader.readAsDataURL(file as any);
            reader.onload = (e: any) => {
                newData.push(e.target.result);
                if (newData.length === uploadResult.length) setData(newData);
            };
        });
    }, [uploadResult]);

    return (
        <div className='img-view-box'>
            {data.map((url, index) => (
                <img src={url} draggable='false' key={'img_' + index} alt='' />
            ))}
        </div>
    );
};

export default ImgPreview;
